import { Injectable } from '@angular/core';
import {BaseProviderService} from "./base-provider.service";
import {Termos} from "../modules/parceiro-completar-dados/termos/model/termos.model";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Observable, Subscription} from "rxjs";
import {map} from "rxjs/operators";
import {AceiteTermos} from "../aplicacao/models/aceite-termos.model";
import {DadosJwtService} from "../core/services/dados-jwt.service";

@Injectable({
  providedIn: 'root'
})
export class AceiteTermosService extends BaseProviderService {
  model = new AceiteTermos()
  parceiroId
  protected module = 'DadosComplementares';
  constructor(
    protected http: HttpClient,
    public dadosJwtService: DadosJwtService,
  ) {
    super(http);
    this.parceiroId = this.dadosJwtService.get().parceiroId;
  }

  get(): Observable<Termos> {
    return this.http.get<Termos>(this.getUrl(this.v1, this.module, ['TermoAceite', this.parceiroId]))
      .pipe(map(x => new Termos(x)));
  }

  getTermo2(termo): Observable<any> {
    return this.http.get<any>(this.getUrl(this.v1, this.module, ['TermoAceite', 'RecuperarTermoS3', termo])).pipe(map(x => x));
  }

  salvar(model: Termos): Observable<Termos> {
    model.parceiroId = this.parceiroId;
    return this.http.post<Termos>(this.getUrl(this.v1, this.module, ['TermoAceite', 'Salvar']), model).pipe(map(x => new Termos(x)));
  }

  confirmaTermo(model: any): Observable<any> {
    return this.http.post<any>(this.getUrl(this.v1, this.module, ['TermoAceite', 'SalvarAssinatura']), model).pipe(map(x => (x)));
  }

  getPublicIp(): Observable<any> {
    const headers = new HttpHeaders({
      'X-PO-No-Message': 'true'
    });
    return this.http.get<any>('https://ipinfo.io?token=cdaab041305bfc', { headers });

  }
  getPublicIp2(): Observable<any> {
    const headers = new HttpHeaders({
      'X-PO-No-Message': 'true'
    });
    return this.http.get<any>('https://shttpbin.org/ip', { headers });
  }

  getPublicIp3(): Observable<any> {
    const headers = new HttpHeaders({
      'X-PO-No-Message': 'true'
    });
    return this.http.get<any>('https://httpbin.org/ip', { headers });
  }

  getPublicIp4(): Observable<any> {
    const headers = new HttpHeaders({
      'X-PO-No-Message': 'true'
    });
    return this.http.get<any>('https://api.ipify.org?format=json', { headers });
  }
}
